import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { Update } from '../update-dialog/update-dialog.component';
import { AdminImageSrcPipe } from '../../shared/pipes/admin-image-src.pipe';

@Component({
  selector: 'app-update-item',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, AdminImageSrcPipe],
  templateUrl: './update-item.component.html',
  styleUrl: './update-item.component.css',
})
export class UpdateItemComponent {
  @Input() update!: Update;
  @Input() index!: number;
  @Input() projectId?: string | null;
  @Output() editUpdate = new EventEmitter<{ update: Update; index: number }>();
  @Output() removeUpdate = new EventEmitter<number>();

  onEdit(): void {
    this.editUpdate.emit({ update: this.update, index: this.index });
  }

  onRemove(): void {
    this.removeUpdate.emit(this.index);
  }
}
